module.exports = __webpack_public_path__ + "img/game_coin.1720234c.png";